<template>
  <div  class='search-panel'>

    <div class="logDiv">
      <img :src="logoUrl"/>
    </div>

    <div class='search-head'>
      <div class='search-text'>
        <div class='my-input' style='margin-top: 110px'>
          <a-input
            :autofocus='true'
            v-model="textSearchInput"
            :placeholder="$t('key17shuruguanjianciduogefenkai')"
            size="large"
            ref='codeInput'
            @pressEnter="toSearch"
            allowClear
            :bordered=false
          />
          <div id='searchOverallButton' class='my-button' @mouseover="mouseOver" @mouseleave="mouseLeave" @click='toSearch'>
            <pt-icon type="icon-quanjusousuo-hei"   style='font-size: 20px;' />
            <span class='my-span'>{{ $t('key10soushuo') }}</span>
          </div>
        </div>
        <div class='search-ul'>
          <div class='search-li' @click='clickChoice(1)' >
            <span :style="choiceNum == 1 ? 'color: #FABF04' : '' " >{{ $t('key17dongtai') }}
            <span v-if='counts.newsCount != undefined'>({{counts.newsCount}})</span>
            </span>
            <div v-if='choiceNum == 1' class='div-click' ></div>
          </div>
          <div class='search-li' @click='clickChoice(2)'>
            <span :style="choiceNum == 2 ? 'color: #FABF04' : '' " >{{ $t('key17xuqiujiaoyi') }}
             <span v-if='counts.dealAndPursuitsCount != undefined'>({{counts.dealAndPursuitsCount}})</span>
            </span>
            <div v-if='choiceNum == 2' class='div-click'></div>
          </div>
          <div class='search-li' @click='clickChoice(3)'>
            <span :style="choiceNum == 3 ? 'color: #FABF04' : '' " >{{ $t('key17qiye') }}
             <span v-if='counts.customerCount != undefined'>({{counts.customerCount}})</span>
            </span>
            <div v-if='choiceNum == 3' class='div-click'></div>
          </div>
          <div class='search-li' @click='clickChoice(4)'>
            <span :style="choiceNum == 4 ? 'color: #FABF04' : '' " >{{ $t('keydasha') }}
            <span v-if='counts.mansionCount != undefined'>({{counts.mansionCount}})</span>
            </span>
            <div v-if='choiceNum == 4' class='div-click'></div>
          </div>
          <div class='search-li'@click='clickChoice(5)'>
            <span :style="choiceNum == 5 ? 'color: #FABF04' : '' " >{{ $t('key17zuyue') }}
            <span v-if='counts.leaseCount != undefined'>({{counts.leaseCount}})</span>
            </span>
            <div v-if='choiceNum == 5' class='div-click'></div>
          </div>
          <div class='search-li'@click='clickChoice(6)'>
            <span :style="choiceNum == 6 ? 'color: #FABF04' : '' " >{{ $t('key17dailixieyi') }}
            <span v-if='counts.agencyCount != undefined'>({{counts.agencyCount}})</span>
            </span>
            <div v-if='choiceNum == 6' class='div-click'></div>
          </div>
        </div>
      </div>
      <pt-icon type="icon-guanbi"  @click.native='cancelSearch' style='font-size: 25px;left:200px;top: 60px;position: relative' />
    </div>

<!--    <div style='margin-top: 170px'>-->
<!--      <pt-empty description='请输入关键词搜索'></pt-empty>-->
<!--    </div>-->

    <div style='overflow-y: auto'>

      <div v-if='choiceNum == 1' class='my-table'  >
        <div style='width: 1080px' v-if='choiceNum == 1 && textSearch != undefined'>
          <newsList :searchOverallFlag='searchOverallFlag' :newsList="news.newsSearchList"  :show-operation="showOperation" @openDrawer="openNewsDetail" :listPagination="listPagination" :loading="news.newsLoading"> </newsList>
        </div>
        <div v-else style='margin-top: 20px'>
          <pt-empty  :description="description?description:$t('baseVO.searchEmpty')" ></pt-empty>
        </div>
      </div>

      <div v-if='choiceNum == 2' class='my-table' >
        <pt-table style='width: 1090px' @rowClick="rowDealAndPurClick" :stickyTableHeader="0" :dataSource='dealAndPursuits.deaAndPurSearchList' :total="dealAndPursuits.total" :loading='dealAndPursuits.deaAndPurLoading'  :size="query.size"  :current="query.current"  @tablePageChange="pageDealAndPurChange"  :showSearch='false'>
          <template slot='columns' >
            <el-table-column  :label="$t('searchOverall.dealAndPursuits.companyName')"
                              min-width='150' align='left'>
              <div slot-scope='scope'>
                <a-tooltip placement="topLeft">
                  <template #title>
                    <span v-html='scope.row.companyShortName'></span>
                  </template>
                  <div v-html='scope.row.companyName ' class='hidden-over'> </div>
                </a-tooltip>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.dealAndPursuits.type')"
                              min-width='100' align='left'>
              <div slot-scope='scope'>
                <div>{{scope.row.type == 3 ? $t('key17xuqiu') : $t('key17jiaoyi') }}</div>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.dealAndPursuits.pace')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <div>
                    {{getTypePace(scope.row.type,scope.row.stage)}}
                </div>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.dealAndPursuits.team')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <avatar-list v-if='scope.row.teamJson'  :max-length="3" :list-length="scope.row.teamJson.length">
                  <avatar-list-item :tips="account.employeeDO.userName" v-for="account in scope.row.teamJson" :key="account.id"
                                    :src="getHeadImg(account.employeeDO.headimg)" />
                </avatar-list>
                <div v-else>~</div>
              </div>
            </el-table-column>
          </template>
        </pt-table>
      </div>

      <div v-if='choiceNum == 3' class='my-table' >
        <pt-table style='width: 1090px' @rowClick="rowCustomerClick" :stickyTableHeader="0" :dataSource='customer.customerSearchList' :total="customer.total" :loading='customer.customerLoading'  :size="query.size"  :current="query.current"  @tablePageChange="pageCustomerChange"  :showSearch='false'>
          <template slot='columns' >
            <el-table-column  :label="$t('searchOverall.customer.name')"
                              min-width='150' align='left'>
              <div slot-scope='scope'>
                <a-tooltip placement="topLeft">
                  <template #title>
                    <span v-html='scope.row.companySortNameCn'></span>
                  </template>
                  <div v-html='scope.row.companyName ' class='hidden-over'> </div>
                </a-tooltip>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.customer.city')"
                              min-width='100' align='left'>
              <div slot-scope='scope'>
                <div>{{scope.row.cityName }}</div>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.customer.createTime')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <div>{{$utils.formatDate(scope.row.createTime)}} </div>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.customer.create')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <div style='display: flex;flex-direction: row' >
                  <span  style='display: flex;flex-direction: row;align-items: center;margin-right: 5px'>
                     <a-avatar
                       slot="avatar"
                       icon="user"
                       shape="circle" :size="30"
                       :src="getHeadImg(scope.row.createImg)"
                     />
                    <span style='margin-left: 6px'>{{scope.row.createName}}</span>
                  </span>
                </div>
              </div>
            </el-table-column>
          </template>
        </pt-table>
      </div>

      <div v-if='choiceNum == 4' class='my-table' >
        <pt-table style='width: 1090px' @rowClick="rowMansionClick" :stickyTableHeader="0" :dataSource='mansion.mansionSearchList' :total="mansion.total" :loading='mansion.mansionLoading'  :size="query.size"  :current="query.current"  @tablePageChange="pageMansionChange"  :showSearch='false'>
          <template slot='columns' >
            <el-table-column  :label="$t('searchOverall.mansion.name')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <a-tooltip placement="topLeft">
                  <template #title>
                    <span v-html='scope.row.name'></span>
                  </template>
                  <div v-html='scope.row.name ' class='hidden-over'> </div>
                </a-tooltip>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.mansion.type')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <div>{{scope.row.mansionType == 'A' ? $t('key17jiaji') : $t('key17yiji') }}</div>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.mansion.city')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <div>{{scope.row.cityStr}} </div>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.mansion.user')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <div style='display: flex;flex-direction: row' v-if='scope.row.mansionUserVOListJson && scope.row.mansionUserVOListJson.length>0'>
                  <span  v-for='mansionUserVO in scope.row.mansionUserVOListJson' style='display: flex;flex-direction: row;align-items: center;margin-right: 5px'>
                     <a-avatar
                       slot="avatar"
                       icon="user"
                       shape="circle" :size="30"
                       :src="getHeadImg(mansionUserVO.headImg)"
                     />
                    <span style='margin-left: 6px'>{{mansionUserVO.userName}}</span>
                  </span>
                </div>
                <div v-else>
                  <span>~</span>
                </div>
              </div>
            </el-table-column>
          </template>
        </pt-table>
      </div>



      <div v-if='choiceNum == 5' class='my-table' >
        <pt-table style='width: 1090px' @rowClick="rowLeaseClick" :stickyTableHeader="0" :dataSource='lease.leaseSearchList' :total="lease.total" :loading='lease.leaseLoading'  :size="query.size"  :current="query.current"  @tablePageChange="pageLeaseChange"  :showSearch='false'>
          <template slot='columns' >
            <el-table-column  :label="$t('searchOverall.lease.customer')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <a-tooltip placement="topLeft">
                  <template #title>
                    <span v-html='scope.row.companyShortNameCN'></span>
                  </template>
                  <div v-html='scope.row.companyName ' class='hidden-over'> </div>
                </a-tooltip>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.lease.mansion')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <a-tooltip placement="topLeft">
                  <template #title>
                    <span v-html='scope.row.mansionName'></span>
                  </template>
                  <div v-html='scope.row.mansionName ' class='hidden-over'> </div>
                </a-tooltip>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.lease.leaseTime')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <div>{{scope.row.startTime}} {{ $t('keyzhi') }} {{scope.row.endTime}} </div>
              </div>
            </el-table-column>
          </template>
        </pt-table>
      </div>


      <!-- 代理协议 -->
      <div v-if='choiceNum == 6' class='my-table'>
        <pt-table style='width: 1090px' @rowClick="rowAgencyClick" :stickyTableHeader="0" :dataSource='agency.agencySearchList' :total="agency.total" :loading='agency.agencyLoading' :current="query.current" :size="query.size"  @tablePageChange="pageAgencyChange"  :showSearch='false'>
          <template slot='columns' >
            <el-table-column  :label="$t('searchOverall.agency.ownerName')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <a-tooltip placement="topLeft">
                  <template #title>
                    <span v-html='scope.row.ownerName'></span>
                  </template>
                <div v-html='scope.row.ownerName ' class='hidden-over'> </div>
                </a-tooltip>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.agency.project')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <a-tooltip placement="topLeft">
                  <template #title>
                    <span v-html='scope.row.mansionNameStr'></span>
                  </template>
                <div v-html='scope.row.mansionNameStr ' class='hidden-over' > </div>
                </a-tooltip>
              </div>
            </el-table-column>
            <el-table-column  :label="$t('searchOverall.agency.agencyTime')"
                              min-width='130' align='left'>
              <div slot-scope='scope'>
                <div>{{scope.row.startDate}} {{$t('keyzhi')}} {{scope.row.endDate}} </div>
              </div>
            </el-table-column>
          </template>
        </pt-table>
      </div>



    </div>

    <!-- 动态 -->
    <pt-drawer top-class='esSearchDrawer' :title="$t('news.title')" :width="1100" :visible="news.newsObj.visible" :show-footer="false"  @close="closeNewsDrawer">
      <div slot="content">
        <news-detail :newsId="news.newsDO ? news.newsDO.id : null" @refreshList="refreshList" :searchOverallFlag='searchOverallFlag' :isCommentEnter="news.newsDO ? news.newsDO.isCommentEnter : null" ></news-detail>
      </div>
    </pt-drawer>

    <!-- 需求 -->
    <pt-drawer top-class='esSearchDrawer' :title="$t('track.trackDetail.detailTitle')" :visible="dealAndPursuits.pursuitsInfo.visible" :width="1100" :show-footer="false" @close="pursuitsInfoClose">
      <div slot="content">
        <track-detail :pursuitsId="dealAndPursuits.pursuitsId"  :hide-edit="true"
                      ></track-detail>
      </div>
    </pt-drawer>

    <!-- 交易 -->
    <pt-drawer top-class='esSearchDrawer' :title="$t('deal.dealDetails.dealDetail.detailTitle.' + dealAndPursuits.dealInfo.dealOriginType)" :visible="dealAndPursuits.dealInfo.visible" :width="1100" :show-footer="false" @close="dealInfoClose">
      <div slot="content">
        <dealDetail :dealId="dealAndPursuits.dealId" v-if="dealAndPursuits.dealInfo.dealOriginType == 1" :searchOverallFlag='searchOverallFlag' ></dealDetail>
        <deal-consultant-detail :dealId="dealAndPursuits.dealId" v-if="dealAndPursuits.dealInfo.dealOriginType == 2" :searchOverallFlag='searchOverallFlag' ></deal-consultant-detail>
      </div>
    </pt-drawer>

    <!-- 企业 -->
    <pt-drawer top-class='esSearchDrawer'  :title="$t('customer.customerDetail.title')"
                :visible="customer.customerInfo.visible" :width="1100" :show-footer="false" @close="customerInfoClose">
      <div slot="content">
        <customer-detail   :is-personl='false' :searchOverallFlag='searchOverallFlag'  :customerId="customer.customerId"></customer-detail>
      </div>
    </pt-drawer>

    <!-- 租约 -->
    <pt-drawer top-class='esSearchDrawer' :title="$t('lease.detail.title')" :visible="lease.leaseInfo.visible" :width="800" @close="leseInfoClose">
      <div slot="content">
        <lease-detail :leaseId="lease.leaseId" :searchOverallFlag='searchOverallFlag'></lease-detail>
      </div>
    </pt-drawer>

    <!-- 代理协议 -->
    <pt-drawer top-class='esSearchDrawer' :title="$t('agencyAgreement.detailTitle')" :visible="agency.agencyInfo.visible" :width="800" @close="agencyInfoClose">
      <div slot="content">
        <agency-agreement-detail  :agencyAgreementId="agency.agencyId" :searchOverallFlag='searchOverallFlag'></agency-agreement-detail>
      </div>
    </pt-drawer>


  </div>
</template>

<script>
import searchOverallApi from '@/api/sys/searchOverall'
import newsApi from '@/api/mine/news'
import newsList from './../../views/mine/news/module/newsList'
import newsDetail from './../../views/mine/news/module/newsDetail'
import AvatarList from '../../components/AvatarList/List'
import AvatarListItem from '../../components/AvatarList/Item'
import { userMixin } from '@/utils/mixin'
import TrackDetail from './../../views/mine/pursuits/module/trackDetail'
import dealDetail from '@/views/mine/deal/dealDetails'
import dealConsultantDetail from '@/views/mine/deal/dealConsultantDetail'
import customerDetail from '@/views/database/customer/module/customerDetail'
import leaseDetail from '@/views/database/lease/module/leaseDetail'
import agencyAgreementDetail from '@/views/database/agencyAgreement/module/agencyAgreementDetail'
import logoUrl from '@/assets/logo.png'

export default {
  name: 'index',
  mixins:[userMixin],
  components:{
    newsList,newsDetail,AvatarList,AvatarListItem,TrackDetail,dealDetail,dealConsultantDetail,leaseDetail,agencyAgreementDetail,
    customerDetail
  },

  data(){
    return{
      logoUrl,
      choiceNum:1,
      searchOverallFlag:true,
      textSearch:undefined,
      textSearchInput:undefined,
      showOperation:true,
      listPagination: {
        onChange: (page,pageSize) => {
          this.listPagination.current = page
          this.query.current = page
          this.query.size = pageSie;
          this.initNewsData()
        },
        showTotal:(total)=>{
          return `共${total}条`
        },
        hideOnSinglePage:true,
        size:'small',
        current: 1,
        pageSize: 10,
      },



      agency:{
        agencyLoading : false,
        agencySearchList:[],
        total: -1,
        agencyId:undefined,
        agencyInfo:{
          visible:false,
        }
      },

      lease:{
        leaseLoading:false,
        leaseSearchList:[],
        total: -1,
        leaseId:undefined,
        leaseInfo:{
          visible:false,
        }
      },

      mansion:{
        mansionLoading:false,
        mansionSearchList:[],
        total: -1
      },

      news:{
        newsLoading:false,
        newsSearchList:[],
        total: -1,
        newsDO:{},
        newsDOLoading:false,
        newsObj:{
          visible:false,
        }
      },

      customer:{
        customerLoading:false,
        customerSearchList:[],
        total: -1,
        customerId:undefined,
        customerInfo:{
          visible:false,
        }
      },

      dealAndPursuits:{
        deaAndPurLoading:false,
        deaAndPurSearchList:[],
        total: -1,
        pursuitsId:undefined,
        dealId:undefined,
        pursuitsInfo:{
          visible: false
        },
        dealInfo:{
          visible: false,
          dealOriginType:1,
        }
      },

      query:{
        current: 1,
        size: 10,
        searchText:undefined,
      },

      counts:{
        agencyCount:undefined,
        mansionCount:undefined,
        customerCount:undefined,
        dealAndPursuitsCount:undefined,
        leaseCount:undefined,
        newsCount:undefined,
      },

      pagination:{
        size: 10,
        current: 1,
        total: 0
      },



    }
  },


  activated(){
    this.focusInput()
    console.log("缓存调用",this.$route)
  },
  deactivated(){
    console.log("缓存调用销毁",this.$route)
    if(this.$route.path != "/searchOverallMansion" ){
      this.initData()
    }
  },
  watch:{
    textSearchInput(){
      if(this.textSearchInput.length == 0){
        this.focusInput()
      }
    }
  },

  methods:{

    initData(){
      this.query.current = 1;
      this.textSearch = undefined
      this.counts.dealAndPursuitsCount = undefined
      this.counts.newsCount = undefined
      this.counts.customerCount = undefined
      this.counts.mansionCount = undefined
      this.counts.agencyCount = undefined
      this.counts.leaseCount = undefined
      this.textSearchInput = undefined
      this.choiceNum = 1
      this.agency.agencySearchList = []
      this.agency.total = 0
      this.customer.customerSearchList = []
      this.customer.total = 0
      this.dealAndPursuits.deaAndPurSearchList = []
      this.dealAndPursuits.total = 0
      this.news.newsSearchList = []
      this.listPagination.total = 0
      this.mansion.mansionSearchList = []
      this.mansion.total = 0
      this.lease.leaseSearchList = []
      this.lease.total = 0
    },


    focusInput(){
      const _this = this
      setTimeout(()=>{
        _this.$refs.codeInput.focus()
      })
    },

    clickChoice(index){
      let codes = JSON.parse(localStorage.getItem("resourceCodes").toUpperCase());
      console.log("codes",codes)
      if(this.textSearch == undefined || this.textSearch == ''){
        this.$message.warning("请先输入关键词搜索")
        return
      }else{
        this.listPagination.current = 1
        this.query.current = 1

        if(index == 6 && codes.indexOf("AGENCYAGREEMENT") != -1 ){
          this.initAgencyData()
          this.choiceNum = index
        }else if(index == 5 && codes.indexOf("LEASE") != -1){
          this.initLeaseData()
          this.choiceNum = index
        }else if(index == 4 && codes.indexOf("MANSIONLIST") != -1){
          this.initMansionData()
          this.choiceNum = index
        }else if(index == 3 && codes.indexOf("MYCUSTOMER") != -1){
          this.initCustomerData()
          this.choiceNum = index
        }else if(index == 2 && (codes.indexOf("PURSUITES") != -1 || codes.indexOf("DEAL") != -1 )  ){
          this.initDealAndPurData()
          this.choiceNum = index
        }else if(index == 1 && codes.indexOf("NEWS") != -1){
          this.query.current = this.listPagination.current
          this.choiceNum = index
          this.initNewsData()
        }else{
          this.$message.warning("您没有权限查看！")
        }
      }
    },

    getHeadImg(headimg){
      return this.$util.getFileUrl(headimg)
    },

    getTypePace(type,stage){
      //交易
      if(type == 2){
       return  this.$t('searchOverall.dealAndPursuits.stageDeal.'+stage)
        //需求
      }else {
        return  this.$t('searchOverall.dealAndPursuits.stagePursuits.'+stage)
      }
    },

    pageAgencyChange(page, pageSize) {
      this.query.current = page
      this.query.size = pageSize
      this.initAgencyData()
    },

    pageLeaseChange(page, pageSize) {
      this.query.current = page
      this.query.size = pageSize
      this.initLeaseData()
    },

    pageMansionChange(page, pageSize) {
      this.query.current = page
      this.query.size = pageSize
      this.initMansionData()
    },

    pageCustomerChange(page, pageSize) {
      this.query.current = page
      this.query.size = pageSize
      this.initCustomerData()
    },

    pageDealAndPurChange(page, pageSize) {
      this.query.current = page
      this.query.size = pageSize
      this.initDealAndPurData()
    },

    rowDealAndPurClick(row){
     let type = row.type
      if(row.showPermission){
        //交易
        if(type == 2){
          this.dealAndPursuits.dealInfo.visible = true
          this.dealAndPursuits.dealId = row.idStr
          this.dealAndPursuits.dealInfo.dealOriginType = row.dealOriginType
        // 3 需求
        }else{
          this.dealAndPursuits.pursuitsInfo.visible = true;
          this.dealAndPursuits.pursuitsId = row.idStr
        }
      }else{
        this.$message.warning("您没有权限查看！")
      }
      console.log('id',row)
    },


    rowCustomerClick(row){
      this.customer.customerId = row.id;
      this.customer.customerInfo.visible = true;
    },

    rowMansionClick(row){
      this.$router.push({path:'/searchOverallMansion',query:{mansionId:row.id}})
    },

    rowLeaseClick(row){
      this.lease.leaseId = row.id;
      this.lease.leaseInfo.visible = true;
    },

    rowAgencyClick(row){
      this.agency.agencyId = row.id;
      this.agency.agencyInfo.visible = true;
    },


    pursuitsInfoClose(){
      this.dealAndPursuits.pursuitsInfo.visible = false;
    },
    dealInfoClose(){
      this.dealAndPursuits.dealInfo.visible = false
    },
    customerInfoClose(){
      this.customer.customerInfo.visible = false
    },
    leseInfoClose(){
      this.lease.leaseInfo.visible = false
    },
    agencyInfoClose(){
      this.agency.agencyInfo.visible = false
    },





    initNewsData(){
      this.query.searchText = this.textSearch
      this.news.newsSearchList = []
      // searchOverallApi.searchOverallInsert().then(res=>{
      //
      // })
      this.news.newsLoading = true

      searchOverallApi.selectNewsAll(this.query).then(res=>{
        if(res.code == 1 ){
          this.news.newsSearchList = res.data.records
          this.listPagination.total = res.data.total
        }
      }).finally(()=>{
        this.news.newsLoading = false
      })
    },

    initCustomerData(){
      this.query.searchText = this.textSearch
      // this.customer.total = -1
      // searchOverallApi.searchOverallInsert().then(res=>{
      //
      // })
      this.customer.customerLoading = true
      searchOverallApi.selectCustomerAll(this.query).then(res=>{
        if(res.code == 1 ){
          this.customer.customerSearchList = res.data.records
          this.customer.total = res.data.total
        }
      }).finally(()=>{
        this.customer.customerLoading = false
      })
    },

    initDealAndPurData(){
      this.query.searchText = this.textSearch
      this.dealAndPursuits.total = -1
      // searchOverallApi.searchOverallInsert().then(res=>{
      //
      // })
      this.dealAndPursuits.deaAndPurLoading = true
      searchOverallApi.selectDealAndPursuitsAll(this.query).then(res=>{
        if(res.code == 1 ){
          this.dealAndPursuits.deaAndPurSearchList = res.data.records
          this.dealAndPursuits.total = res.data.total
        }
      }).finally(()=>{
        this.dealAndPursuits.deaAndPurLoading = false
      })
    },

    initAgencyData(){
      this.query.searchText = this.textSearch
      this.agency.total = -1
      // searchOverallApi.searchOverallInsert().then(res=>{
      //
      // })
      this.agency.agencyLoading = true
      searchOverallApi.selectAgencyAll(this.query).then(res=>{
        if(res.code == 1 ){
          this.agency.agencySearchList = res.data.records
          this.agency.total = res.data.total
        }
      }).finally(()=>{
        this.agency.agencyLoading = false
      })
    },

    initMansionData(){
      this.query.searchText = this.textSearch
      this.mansion.total = -1
      // searchOverallApi.searchOverallInsert().then(res=>{
      //
      // })
      this.mansion.mansionLoading = true
      searchOverallApi.selectMansionAll(this.query).then(res=>{
        if(res.code == 1 ){
          this.mansion.mansionSearchList = res.data.records
          this.mansion.total = res.data.total
        }
      }).finally(()=>{
        this.mansion.mansionLoading = false
      })
    },


    initLeaseData(){
      this.query.searchText = this.textSearch
      this.lease.total = -1
      // searchOverallApi.searchOverallInsert().then(res=>{
      //
      // })
      this.lease.leaseLoading = true
      searchOverallApi.selectLeaseAll(this.query).then(res=>{
        if(res.code == 1 ){
          this.lease.leaseSearchList = res.data.records
          this.lease.total = res.data.total
        }
      }).finally(()=>{
        this.lease.leaseLoading = false
      })
    },


    toSearch(){

      let textSearch = this.textSearchInput
      let codes = JSON.parse(localStorage.getItem("resourceCodes").toUpperCase());

      if(textSearch == undefined || textSearch == ''){
        this.$message.warning("请输入关键字！")
        return
      }
      this.textSearch = textSearch
      this.$loading.show();
      searchOverallApi.searchOverallList({searchText:textSearch}).then(res=>{
        if(res.code == 1 ){
          // PURSUITES 需求 DEAL 交易  NEWS 动态 MYCUSTOMER 企业 MANSIONLIST 大厦 LEASE 租约 AGENCYAGREEMENT 代理协议
          let index = 0;
          if(codes.indexOf("NEWS") != -1 ){
            this.counts.newsCount = res.data.newsCount
            index = 1 ;
          }
          if(codes.indexOf("PURSUITES") != -1 || codes.indexOf("DEAL") != -1 ){
            this.counts.dealAndPursuitsCount = res.data.dealAndPursuitsCount
            if(index == 0 ){
              index = 2
            }
          }
          if(codes.indexOf("MYCUSTOMER") != -1 ){
            this.counts.customerCount = res.data.customerCount
            if(index == 0 ){
              index = 3
            }
          }
          if(codes.indexOf("MANSIONLIST") != -1 ){
            this.counts.mansionCount = res.data.mansionCount
            if(index == 0 ){
              index = 4
            }
          }
          if(codes.indexOf("LEASE") != -1 ){
            this.counts.leaseCount = res.data.leaseCount
            if(index == 0 ){
              index = 5
            }
          }
          if(codes.indexOf("AGENCYAGREEMENT") != -1 ){
            this.counts.agencyCount = res.data.agencyCount
            if(index == 0 ){
              index = 6
            }
          }
          this.query.current = 1
          this.listPagination.current = 1
          this.clickChoice(index)
        }
      }).finally(()=>{
        this.$loading.hide();
      })
    },
    toDelete(){
      searchOverall.searchOverallDelete().then(res=>{
      })
    },
    toInsert(){
      searchOverall.searchOverallInsert().then(res=>{
      })
    },


    openNewsDetail(item){
      if(this.showOperation){
        this.news.newsDOLoading = true
        newsApi.selectOne(item.id).then(res=>{
          if(res.code == 1){
            this.news.newsObj.visible = true;
            this.news.newsDO = item
          }
        }).finally(()=>{
          this.news.newsDOLoading = false
        })
      }
    },
    closeNewsDrawer(){
      this.news.newsObj.visible = false;
    },
    refreshList(){
      this.closeNewsDrawer()
      this.initNewsData()
    },


    mouseOver(){
      document.getElementById('searchOverallButton').className = 'my-button-one'
      this.searchFlag = false
    },
    mouseLeave(){
      document.getElementById('searchOverallButton').className = 'my-button'
      this.searchFlag = true
    },

    onSearch(){

    },

    cancelSearch(){
      this.$router.go(-1);
    }


  }
}






</script>


<style>

</style>

<style lang="less" scoped>


.search-panel{
  position: fixed;
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  z-index: 1000;

  .search-head{
    background: url("https://bms2.oss-cn-shenzhen.aliyuncs.com/searchbg.png");
    height: 250px;
    width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: row;
  }

  .search-text{
    width: 610px;
  }

  .search-ul{
    color: #FFFFFF;
    margin-top: 48px;
    display: flex;
    height: 40px;
    justify-content: space-between;

    .div-click{
      height: 4px;
      width: 28px;
      background-color: #FABF04
    }

  }
  .search-li{
    padding-top: 5px;
    line-height: 32px !important;
    height: 40px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .my-input{
    display: flex;
    flex-direction: row;
    padding: 1px;
    background-color: #FABF04;
    border-radius: 6px 6px 6px 6px;

    .my-button{
      background-color: #FABF04;
      border-radius: 0 6px 6px 0;
      width: 100px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .my-button-one{
      background-color: #EDB400;
      border-radius: 0 6px 6px 0;
      width: 100px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }

    .my-span{
      margin-left: 5px;
      font-size: 16px;
      color: #333333;
      font-weight: 600;
    }

  }

  .my-table{
    margin-top: 40px;
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .hidden-over{
    width: 300px;
    overflow: hidden;//溢出隐藏
    text-overflow: ellipsis;//属性值表示当对象内文本溢出时显示省略标记，省略标记插入的位置是最后一个字符。
    white-space: nowrap;//只保留一个空白，文本不会换行，会在在同一行上继续，直到遇到br标签为止。\
  }


}

.ant-drawer-content-wrapper{
  top:0 !important;
}

.my-input /deep/ .ant-input{
  border: none;
  border-radius: 6px 0 0 6px !important;
  background-color: #FFFFFF !important;
  font-weight: 600;
  height: 50px;
  font-size: 14px;
}

.my-table /deep/ .pt-table-header th{
  background-color: #FFFFFF !important;

}

.my-table /deep/ .el-table th{

  padding: 0 !important;
}

.my-table /deep/  .pt-table .pt-table-header th > .cell{
  font-size: 12px !important;
  color: #999999;
  font-weight: 600;
}

.my-table /deep/ .el-table__row{
  background-color: #F9F9F9 ;
  height: 60px !important;
}
.my-table /deep/ .el-table th.is-leaf{
  border-bottom: 0px solid #FFFFFF !important;
}
.my-table /deep/ .pt-table td, .pt-table th{
  border-bottom: 10px solid #FFFFFF !important;
  font-size: 12px !important;
  font-weight: 600;
}


.logDiv {
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  z-index: 9;
  top: 0;
  left: 50px;

  img{
    height: 40px;
  }
}


</style>


<style>

.ant-input-affix-wrapper .ant-input-suffix{
  right: 25px !important;
}

.ant-input-affix-wrapper .ant-input:not(:last-child){
  padding-left:20px !important;
}

  .esSearchDrawer .ant-drawer-content-wrapper{
    top: 0 !important;
  }

</style>
